import FlashMessages from '@/components/FlashMessages'
import Sidebar from '@/components/Sidebar'
import TopNavbar from '@/components/TopNavbar'
import { SharedProps } from '@/types'
import { usePage } from '@inertiajs/react'
import { AppShell, Burger, Container, Group, Stack } from '@mantine/core'
import { ReactNode, useEffect, useState } from 'react'

export default function Layout({ children }: { children: ReactNode }) {
  const { props, url } = usePage<SharedProps>()
  const hasOrganization = !!props.current_organization
  const [opened, setOpened] = useState(false)

  useEffect(() => {
    setOpened(false)
  }, [url])

  return (
    <>
      <FlashMessages />
      <AppShell
        header={{ height: 60 }}
        navbar={hasOrganization ? { width: 260, breakpoint: 'lg', collapsed: { mobile: !opened } } : undefined}
        padding="md"
      >
        <AppShell.Header>
          <Group h="100%" px="md">
            {hasOrganization && <Burger opened={opened} onClick={() => setOpened(!opened)} hiddenFrom="lg" size="sm" />}
            <TopNavbar />
          </Group>
        </AppShell.Header>
        {hasOrganization && (
          <AppShell.Navbar p="sm">
            <Sidebar />
          </AppShell.Navbar>
        )}
        <AppShell.Main>
          <Container size="xl" py="lg">
            <Stack gap="xl">{children}</Stack>
          </Container>
        </AppShell.Main>
      </AppShell>
    </>
  )
}
